export const uk = {
    LEFT: 'Ліворуч: перехід до попереднього дня.',
    RIGHT: 'Вправо: перехід до наступного дня.',
    DOWN: 'Вниз: перейти до наступного рядка.',
    UP: 'Вгору: перейти до попереднього рядка.',
    PGUP: 'Вгору: перехід до попереднього місяця.',
    PGDOWN: 'PgDown: перейти на наступний місяць.',
    HOME: 'Будинку: перехід до попереднього року.',
    END: 'Кінець: перенести на наступний рік.',
    ESC: 'Еку/сьогодні/закрити-закрити календар. Інструкції',
    TITLE: 'Клавіатура '
};
